import { cx } from "../../ui/cx";
import { formatPesos } from "../../../lib/money";
import { PosChip } from "../partLabels";
import type { PlateRow } from "./plateRows";

/** The phone parts list (mobile kit PartRow): each listing a 64px row, tapped to open its part. */
export function PlatePartsList({ rows, selectedKey, onPick }: { rows: PlateRow[]; selectedKey: string | null; onPick: (row: PlateRow) => void }) {
  return (
    <ul className="m-0 flex list-none flex-col gap-2 p-0">
      {rows.map((row) => (
        <li key={row.key}>
          <button
            type="button"
            onClick={() => onPick(row)}
            className={cx(
              "flex min-h-16 w-full cursor-pointer items-center gap-3 rounded-md border bg-surface-card p-3 text-left",
              row.key === selectedKey ? "border-green-700" : "border-border-subtle",
            )}
          >
            <PosChip label={row.position.position_number} />
            <span className="min-w-0 flex-1">
              <span className="block truncate type-sku [font-size:var(--text-xs)] text-ink-600">{row.listing.reference_number ?? row.listing.sku}</span>
              <span className="block type-body [font-size:var(--text-sm)] leading-snug text-text-strong">{row.listing.name}</span>
              {!row.listing.in_stock && <span className="block type-small text-danger-700">Out of stock</span>}
            </span>
            <span className="flex-none type-price [font-size:var(--text-base)]">{formatPesos(row.listing.price_cents)}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
